import { normalizeArrayField } from "../../pages/Settings/BrandSetup/utils/formDataTransformers";
import {
  ALERT_COMPETITOR_SCOPE_DESCRIPTION,
  ALERT_COMPETITOR_SCOPE_MISSING_COMPETITORS_DESCRIPTION,
  ALERT_COMPETITOR_SCOPE_MISSING_COMPETITORS_TITLE,
  ALERT_COMPETITOR_SCOPE_TITLE,
  BUTTON_CONFIGURE_BRAND,
  BUTTON_CONFIGURE_COMPETITORS,
} from "../../i18n/keysTranslations";

export const COMPETITOR_SCOPE_BLOCK_REASON_MISSING_BRAND_SETUP =
  "missing_brand_setup";
export const COMPETITOR_SCOPE_BLOCK_REASON_MISSING_COMPETITORS =
  "missing_competitors";

export const COMPETITOR_SCOPE_COMPETITORS_SECTION_ID = "competitors-section";
export const COMPETITOR_SCOPE_SETTINGS_PATH = "/settings";
export const COMPETITOR_SCOPE_COMPETITORS_SETTINGS_PATH = `/settings#${COMPETITOR_SCOPE_COMPETITORS_SECTION_ID}`;

export const hasBrandContext = ({ businessName, businessDescription } = {}) =>
  Boolean(businessName && businessDescription);

export const hasBusinessCompetitors = (businessCompetitors) =>
  normalizeArrayField(businessCompetitors).length > 0;

export const getCompetitorScopeBlockReason = (brandData = {}) => {
  if (!hasBrandContext(brandData)) {
    return COMPETITOR_SCOPE_BLOCK_REASON_MISSING_BRAND_SETUP;
  }

  if (!hasBusinessCompetitors(brandData.businessCompetitors)) {
    return COMPETITOR_SCOPE_BLOCK_REASON_MISSING_COMPETITORS;
  }

  return null;
};

export const getCompetitorScopeAlertCopy = (blockReason) => {
  if (blockReason === COMPETITOR_SCOPE_BLOCK_REASON_MISSING_COMPETITORS) {
    return {
      titleKey: ALERT_COMPETITOR_SCOPE_MISSING_COMPETITORS_TITLE,
      descriptionKey: ALERT_COMPETITOR_SCOPE_MISSING_COMPETITORS_DESCRIPTION,
      confirmButtonKey: BUTTON_CONFIGURE_COMPETITORS,
      settingsPath: COMPETITOR_SCOPE_COMPETITORS_SETTINGS_PATH,
    };
  }

  return {
    titleKey: ALERT_COMPETITOR_SCOPE_TITLE,
    descriptionKey: ALERT_COMPETITOR_SCOPE_DESCRIPTION,
    confirmButtonKey: BUTTON_CONFIGURE_BRAND,
    settingsPath: COMPETITOR_SCOPE_SETTINGS_PATH,
  };
};
